import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ReportReceiptItem = ResultOf<
  typeof reportReceiptsQuery
>["reportReceipts"]["receipts"][number];

export type ReportReceiptTotals = ResultOf<
  typeof reportReceiptsQuery
>["reportReceipts"]["totals"];

export const reportReceiptsQuery = graphql(`
  query ReportReceipts($rangeStartDate: String!, $rangeEndDate: String!) {
    reportReceipts(
      range_start_date: $rangeStartDate
      range_end_date: $rangeEndDate
    ) {
      receipts {
        id
        type
        description
        amount_exc_tax
        amount_tax
        amount_inc_tax
        claimable_amount_inc_tax
        claimable_amount_tax
        currency
        date
        created_at
        related_type
        related_id
        related_reference
      }
      totals {
        total_receipts
        total_amount_exc_tax
        total_amount_tax
        total_amount_inc_tax
        total_claimable_amount_inc_tax
        total_claimable_amount_tax
      }
    }
  }
`);
